import { ReactComponent as Menu2Icon01 } from "../../assets/svg/menu2/01.svg";
import { ReactComponent as Menu2Icon02 } from "../../assets/svg/menu2/02.svg";
import { ReactComponent as Menu2Icon03 } from "../../assets/svg/menu2/03.svg";
import { ReactComponent as Menu2Icon04 } from "../../assets/svg/menu2/04.svg";
import { ReactComponent as Menu2Icon05 } from "../../assets/svg/menu2/05.svg";
import { ReactComponent as Menu2Icon06 } from "../../assets/svg/menu2/06.svg";
import { ReactComponent as Menu2Icon07 } from "../../assets/svg/menu2/07.svg";
import { ReactComponent as Menu2Icon08 } from "../../assets/svg/menu2/08.svg";

let initState = {
    baseUrl: 'https://dev.protones.it/rendi-api',
    topTab:{
        nowId : 1,
        items:[
            {
                id: 1,
                name: "REPERTORI",
                icon: <Menu2Icon01 />,
            },
            {
                id: 2,
                name: "PROGRAMMI",
                icon: <Menu2Icon02 />,
            },
            {
                id: 3,
                name: "REPORT",
                icon: <Menu2Icon03 />,
            },
            {
                id: 4,
                name: "ASSEGNAZIONI",
                icon: <Menu2Icon04 />,
            },
            {
                id: 5,
                name: "IMPAGINAZIONE",
                icon: <Menu2Icon05 />,
            },
            {
                id: 6,
                name: "RENDICONTAZIONE",
                icon: <Menu2Icon06 />,
            },
            {
                id: 7,
                name: "CLIENTI",
                icon: <Menu2Icon07 />,
            },
            {
                id: 8,
                name: "ANALISI",
                icon: <Menu2Icon08 />,
            }
        ]
    },
    leftTab:{
        flag: true,
        searchTab:{
            flag: true
        },
        filterTab:{
            flag: true
        }
    },
    rightTab:{
        flag: true,
        todoTab:{
            flag: true,
            count: 3
        },
        notficheTab:{
            flag: true,
            count: 3
        },
        chatTab:{
            flag: true,
            count: 3
        }
    },
    footer:{
        totalTime : 129,
        waveSliderFlag : false,
        playList : {
            flag : false,
            count : 3,
            headers : [ "", "", "Titolo", "Artisti", "Autori", "Editori", "Etichetta", "ISRC", "Durata", "Area" ],
            items : [
                [ "", "", "Opera 01…", "Artisi 01…", "Autori 01…", "Editori 01…", "Etichetta 01…", "ISRC 01…", "00:00", "Area 01…" ],
                [ "", "", "Opera 02…", "Artisi 02…", "Autori 02…", "Editori 02…", "Etichetta 02…", "ISRC 02…", "00:00", "Area 02…" ],
                [ "", "", "Opera 03…", "Artisi 03…", "Autori 03…", "Editori 03…", "Etichetta 03…", "ISRC 03…", "00:00", "Area 03…" ]
            ]
        }
    },
    loginPage:{
        username: "username",
        password: "password",
        passFlag: false,
        wrongFlage: false,
        loggingOutFlag : false
    },
    toolKit: {
        top: 122,
        right:122,
        dragFlag: false
    },
    modal:{
        flag: false,
        data: {}
    },
    savedProgrammiTab:[
        {
            totalElements: 0,
            searchValue: [],
            filterData: [],
            programmiDispData: [],
            headings: [[],[]],
            detailId: [-1 -1],
            detailHeadings: [],
            subTabId: 0,
            modalFlag: false,
            modalData: {}
        }
    ]
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case 'LOGIN_CHECK': {
            return {
                ...state,
                loginPage:{
                    ...state.loginPage,
                    passFlag: (action.payload.username === state.loginPage.username 
                        && action.payload.password === state.loginPage.password),
                    wrongFlage: !(action.payload.username === state.loginPage.username 
                        && action.payload.password === state.loginPage.password)
                }
            }
        }
        case 'SELECT_TOP_TAB': {
            return {
                ...state,
                topTab:{
                    ...state.topTab,
                    nowId: action.payload.id
                },
                leftTab:{
                    ...state.leftTab,
                    flag: true,
                    searchTab:{
                        ...state.leftTab.searchTab,
                        flag: true
                    },
                    filterTab:{
                        ...state.leftTab.filterTab,
                        flag: true
                    }
                },
            }
        }
        case 'LEFT_BAR_CLICKED': {
            return {
                ...state,
                leftTab:{
                    ...state.leftTab,
                    flag: !state.leftTab.flag
                },
            }
        }
        case 'SEARCH_BAR_CLICKED': {
            return {
                ...state,
                leftTab:{
                    ...state.leftTab,
                    searchTab:{
                        ...state.leftTab.searchTab,
                        flag: !state.leftTab.searchTab.flag
                    }
                }
            }
        }
        case 'FILTER_BAR_CLICKED': {
            return {
                ...state,
                leftTab:{
                    ...state.leftTab,
                    filterTab:{
                        ...state.leftTab.filterTab,
                        flag: !state.leftTab.filterTab.flag
                    }
                }
            }
        }
        case 'RIGHT_BAR_CLICKED': {
            return {
                ...state,
                rightTab:{
                    ...state.rightTab,
                    flag: !state.rightTab.flag
                }
            }
        }
        case 'CHAT_BAR_CLICKED': {
            return {
                ...state,
                rightTab:{
                    ...state.rightTab,
                    chatTab:{
                        ...state.rightTab.chatTab,
                        flag: !state.rightTab.chatTab.flag
                    }
                }
            }
        }
        case 'TODO_BAR_CLICKED': {
            return {
                ...state,
                rightTab:{
                    ...state.rightTab,
                    todoTab:{
                        ...state.rightTab.todoTab,
                        flag: !state.rightTab.todoTab.flag
                    }
                }
            }
        }
        case 'FOOTER_LIST_BTN_CLICKED': {
            return {
                ...state,
                footer:{
                    ...state.footer,
                    playList:{
                        ...state.footer.playList,
                        flag: !state.footer.playList.flag
                    }
                }
            }
        }
        case 'FOOTER_GREEN_AREA_CLICKED': {
            return {
                ...state,
                footer:{
                    ...state.footer,
                    waveSliderFlag: !state.footer.waveSliderFlag
                }
            }
        }
        case 'LOGGING_OUT': {
            return {
                ...state,
                loginPage:{
                    ...state.loginPage,
                    loggingOutFlag: !state.loginPage.loggingOutFlag
                }
            }
        }
        case 'TOOLKIT_CLICKED': {
            return {
                ...state,
                toolKit:{
                    ...state.toolKit,
                    dragFlag : true
                }
            }
        }
        case 'TOOLKIT_RELEASED': {
            return {
                ...state,
                toolKit:{
                    ...state.toolKit,
                    dragFlag : false
                }
            }
        }
        case 'TOOLKIT_MOVE': {
            return {
                ...state,
                toolKit:{
                    ...state.toolKit,
                    top: state.toolKit.top + action.payload.y,
                    right: state.toolKit.right - action.payload.x
                }
            }
        }
        case 'SET_MODAL_DATA': {
            return {
                ...state,
                modal:{
                    flag: state.modal.flag,
                    data: {...action.payload.obj}
                }
            }
        }
        case 'SET_MODAL_FLAG': {
            if(action.payload.flag){
                return {
                    ...state,
                    modal:{
                        ...state.modal,
                        flag: true
                    }
                }
            }
            else{
                return {
                    ...state,
                    modal:{
                        flag: false,
                        data: {}
                    }
                }
            }
        }
        case 'SET_SAVED_PROGRAMMI_TAB': {
            return {
                ...state,
                savedProgrammiTab:[
                    ...state.savedProgrammiTab.slice(0, action.payload.index),
                    action.payload.obj,
                    ...state.savedProgrammiTab.slice(action.payload.index+1),
                ]
            }
        }
        default: return state
    }

}

export default reducer;